// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8-za3","left":"styles_left__vCG1I"};